import { Directive } from '@angular/core';

@Directive({ selector: '[st-footer]' })
export class FooterDirective {}
